module.exports = __webpack_public_path__ + "img/3d.b3979622.png";